<template>
  <div id="integral">
    <div class="content">
      <a-table
          :columns="columns2"
         :dataSource="companyData"
         rowKey="supplierCompanyId"
         :pagination="params"
         @change='paginationChange'
      >
        <div
            slot="filterDropdown"
            slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
            style="padding: 8px"
        >
          <a-input
              placeholder="请输入"
              v-model="searchTxt"
              :value="selectedKeys[0]"
              style="width: 188px; margin-bottom: 8px; display: block;"
              @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
              @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
          />
          <a-button
              type="primary"
              icon="search"
              size="small"
              style="width: 90px; margin-right: 8px"
              @click="() => search()"
          >
            搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="searchTxt = '', search()">
            重置
          </a-button>
        </div>
        <a-icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
        />
        <span slot="action" slot-scope="record">
          <a @click="infoId = record.id, lookData(record)">详情</a>
          <a-divider type="vertical" />
          <a @click="$router.push({
            path: `/shopDetail`,
            query: {
              id: record.supplierCompanyId,
              name: record.supplierCompanyName,
              supplierCompanyLogo: record.supplierCompanyLogo,
              phone: record.supplierCompanyPhone?.[0] || '',
              person: record?.supplierCompanyContacts?.[0] || ''
            }
          })">兑换</a>
        </span>

      </a-table>
    </div>

    <a-modal
      title="详情"
      :dialogStyle="{ minWidth: '1000px' }"
      :bodyStyle="{ maxHeight: '600px', overflow: 'auto' }"
      :visible.sync="visibleDetails"
      @cancel="visibleDetails = false"
    >
      <div>
        <a-tabs :defaultActiveKey="activeKey" @change="tabChange">
          <a-tab-pane v-for="tab in tabList" :key="tab.key" :tab="tab.tab">
          </a-tab-pane>
        </a-tabs>
        <div>
          <a-table
              :loading="tableLoading"
              :ref="activeKey"
              size="default"
              rowKey="id"
              :columns="columns"
              :dataSource="loadData"
              :pagination="{ ...pagination, current: activeData.params.current}"
              @change='e => paginationChange2(e, tab)'
          >
            <span slot="recordType" slot-scope="text">{{ text === 1 ? '订单' : '兑换' }}</span>
            <span slot="recordTypeTitle">{{ activeKey === 'gain' ? '获取来源' : '用途'}}</span>
            <span slot="pointsTitle">{{ activeKey === 'gain' ? '获取' : '使用'}}</span>
            <span slot="recordTimeTitle">{{ activeKey === 'gain' ? '获取时间' : '使用时间'}}</span>
            <span slot="action" slot-scope="record">
              <a v-if="!(record.recordType === 3 && activeKey === 'consumption') && record.orderId" @click="det(record)">详情</a>
            </span>
          </a-table>
        </div>
      </div>
    </a-modal>

    <order-detail :visible.sync="visible" :orderId="orderId"/>
    <platform-order-detail :visible.sync="platformVisible" :orderId="orderId"/>
  </div>
</template>
<script>
import {loadPoints, loadPointsRecord, supplierJifenAll} from "@/api/account";
import OrderDetail from "@/views/account/modules/OrderDetail";
import PlatformOrderDetail from "@/views/account/modules/PlatformOrderDetail";

export default {
  components: {
    OrderDetail,
    PlatformOrderDetail
  },
  data () {
    return {
      infoId: '',
      searchTxt: '',
      companyData: [],
      visibleDetails: false,
      columns2: [
        {
          title: '序号',
          customRender: (text, record, index) => `${index + 1}`
        },
        {
          title: '供应商',
          dataIndex: 'supplierCompanyName',
          key: 'supplierCompanyName',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender',
          },
          onFilterDropdownVisibleChange: visible => {
            if(!visible) this.searchTxt = ''
            // console.log('筛选面板显示状态：', visible);
          }
        },
        {
          title: '总积分',
          dataIndex: 'points',
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' }
        }
      ],
      columns: [
        {
          dataIndex: 'recordType',
          scopedSlots: { customRender: 'recordType', title: 'recordTypeTitle' }
        },
        {
          title: '描述',
          dataIndex: 'recordContent'
        },
        {
          dataIndex: 'points',
          scopedSlots: { title: 'pointsTitle' }
        },
        {
          dataIndex: 'recordTime',
          scopedSlots: { title: 'recordTimeTitle' }
        },
        {
          title: '',
          scopedSlots: { customRender: 'action' }
        }
      ],
      tabList: [
        {
          key: 'gain',
          tab: '获取记录',
          data: [],
          params: {
            size: 10,
            current: 1,
            pointsRecordType: 1
          },
          total: 0
        },
        {
          key: 'consumption',
          tab: '使用记录',
          data: [],
          params: {
            size: 10,
            current: 1,
            pointsRecordType: 2
          },
          total: 0
        }
      ],
      params: {
        total: 0,
        pageSize: 10,
        size: '10',
        current: 1
      },
      activeKey: 'gain',
      gainRecordList: [],
      consumptionRecordList: [],
      tableLoading: false,
      platformVisible: false,
      visible: false,
      orderId: ''
    }
  },
  computed: {
    loadData () {
      return this.tabList.find(r => r.key === this.activeKey).data
    },
    activeData () {
      return this.tabList.find(r => r.key === this.activeKey)
    },
    pagination () {
      const _this = this
      return {
        pageSize: 10,
        total: this.activeData.total,
        onChange (page, pageSize) {
          _this.activeData.params.current = page
          _this.getRecordPage(_this.activeData)
        }
      }
    }
  },
  mounted () {
    // this.getPoints()
    this.search()

  },
  methods: {
    paginationChange2 (e, d) {
      // console.log('--------', e)
      d.params.current = e.current
      this.getRecordPage(d, {id: this.infoId})
      // this.activeKey = key
      //
      // this.params.current = e.current
      // this.search()
    },
    paginationChange (e) {
      this.params.current = e.current
      this.search()
    },
    lookData (e) {
      this.visibleDetails = true
      this.tabList.forEach(r => {
        r. params.current = 1
        this.getRecordPage(r, e)
      })
    },
    search () {
      supplierJifenAll({...this.params, supplierCompanyName: this.searchTxt }).then(res => {
        this.companyData = res.data.records.map(it => ({
          ...it,
          supplierCompanyContacts: it.supplierCompanyContacts?.split(','),
          supplierCompanyPhone: it.supplierCompanyPhone?.split(',') }))
        this.params.total = res.data.total
      })
    },
    tabChange (key) {
      this.activeKey = key
    },
    getRecordPage (tab, e) {
      this.tableLoading = true
      try {
        loadPointsRecord({...tab.params, pointsId: this.infoId}).then(res => {
          tab.data = res.data.records
          tab.total = res.data.total
        })
      } finally {
        this.tableLoading = false
      }
    },
    det (record) {
      if (this.activeKey === 'gain') {
        this.platformVisible = true
      } else {
        this.visible = true
      }
      this.orderId = record.orderId
    }
  }
}
</script>
<style lang="less" scoped>
#integral {
  border-radius: 10px;
  background: #fff;
  //padding: 20px;
}
.content_top {
  height: auto;
  margin-bottom: 16px;
  p {
    font-weight: 550;
    font-size: 16px;
    margin: 0;
    span {
      font-size: 26px;
      font-weight: 600;
    }
  }
}
.content {
  min-height: 705px;
  /deep/ .ant-tabs-nav-wrap{
    font-size: 16px;
    font-weight: 550;
  }
}
</style>
